import './Spinner.scss';
import classNames from "classnames";

export default function Spinner({className}) {
  return (
    <span className={classNames(['spinner', className])}>
      <span></span>
      <span></span>
    </span>
  )
}
